export function calculateReadingTime(text: string) {
  const averageWPM = 200

  // Remove repeated characters and punctuations
  const adjustedText = text.replace(/(.)\1+/g, '$1').replace(/([.!?])\s*\1+/g, '$1')

  // Split text into words and count characters
  const adjustedWords = adjustedText.trim().split(/\s+/)
  const adjustedWordCount = adjustedWords.length

  // Assuming an average word length of 5 characters
  const averageWordLength = 5

  // Adjusted reading time in minutes
  const adjustedTime = (adjustedWordCount / averageWPM) * (averageWordLength / 5)

  // Calculate hours and minutes
  const hours = Math.floor(adjustedTime / 60)
  const minutes = Math.round(adjustedTime % 60)

  let formattedAdjustedTime
  if (hours > 0) {
    formattedAdjustedTime = `${hours} hour${hours > 1 ? 's' : ''} ${minutes > 0 ? `and ${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
  } else {
    formattedAdjustedTime = minutes > 1 ? `${minutes} min read` : 'Less than 1 min read'
  }

  return formattedAdjustedTime
}
